import { Component, OnInit , Output,EventEmitter,Input,AfterContentInit} from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, CandidatesService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-voluntary-modal',
    templateUrl: './voluntary-modal.html',
    styleUrls: ['./voluntary-modal.scss']
})

export class VoluntaryModalComponent implements OnInit, AfterContentInit {
    @Output() notifyParent = new EventEmitter<any>();
    @Input() isEdit  = false;
    @Input() voluntary = {
        id :null ,
        start_date : null,
        end_date : null,
        organization : null,
        role : null,
        description : null,
        location : null,
        is_present: false
    }
    isLoading      = false;
    constructor(private toastr :ToastrService,private authService: AuthService,private candidatesService: CandidatesService, private location: PlatformLocation,public activeModal: NgbActiveModal) {
    	location.onPopState(() => { this.activeModal.close();});
    }

    ngOnInit() {}

    closeModal(){
    	this.activeModal.close({status:true});
    }

    canAdd(){
        return this.isLoading || (this.voluntary.start_date == null || this.voluntary.organization == null || this.voluntary.role == null|| ( this.voluntary.end_date == null && !this.voluntary.is_present ) );
    }

    updateUserProfile(){
        var _ref = Object.assign({},this.voluntary);
        _ref.start_date = this.voluntary.start_date.year+"-"+this.voluntary.start_date.month+"-"+this.voluntary.start_date.day
        if(!this.voluntary.is_present)
            _ref.end_date = this.voluntary.end_date.year+"-"+this.voluntary.end_date.month+"-"+this.voluntary.end_date.day
        else
            _ref.end_date = null;
        this.isLoading = true;
        if(!this.isEdit)
            this.candidatesService.addVoluntary(_ref,this.authService.user.candidate?.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.voluntary = {
                    id :null ,
                    start_date : null,
                    end_date : null,
                    organization : null,
                    role : null,
                    description : null,
                    location : null,
                    is_present: false
                };
                this.notifyParent.emit(true);
                this.closeModal();
            },(error)=>{
                this.isLoading = false;
                this.toastr.error("Something wrong, try again later", "Add Voluntary Experience");
            });
        else
            this.candidatesService.updateVoluntary(_ref,this.authService.user.candidate?.id,this.voluntary.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.voluntary = res.data;
                this.notifyParent.emit(true);
                this.closeModal();
            },(error)=>{
                this.isLoading = false;
                this.toastr.error("Something wrong, try again later", "Update Voluntary Experience");
            });
    }

    resetDate(){
        this.voluntary.end_date = null;
    }

    ngAfterContentInit () {
        if(this.isEdit && this.voluntary.start_date){
            const temp1 = new Date(this.voluntary.start_date)
            this.voluntary.start_date = {year:temp1.getFullYear(),month:temp1.getMonth()+1,day:temp1.getDate()};
        }
        if(this.isEdit && this.voluntary.end_date){
            const temp2 = new Date(this.voluntary.end_date)
            this.voluntary.end_date   = {year:temp2.getFullYear(),month:temp2.getMonth()+1,day:temp2.getDate()};
        }
    }
}
